const {App, react2angular} = require('../../../../react-dist/nativeEsigCertificateViewer').reactLibrary;

// first array is basic prop injection, the second array is service injection
angular
    .module('jv.React.CertificateViewer', [])
    .component('reactCertificateViewer', react2angular(App, [
        'translations',
        'certificateFile',
        'certificateFileName',
        'registerDownload'
    ], []));
    